import { Outlet, Link, useLocation } from "react-router-dom";
import './Layout_styles.css'
import VectorFieldBackground from "./VectorFieldBackground";


export default function Layout() {
  const { pathname } = useLocation();
  const isHome = pathname === '/';

  // const language_array = [ 'en', 'fr', 'sp' ]
  // const languages  = {
  //   'en' : 'Cultural Center' ,
  //   'fr' : 'Centre Culturel',
  //   'sp' : 'Centro Cultural'
  // }

  // const [ lang, langState ] = useState( 'en' )


  return (
    <>
    <VectorFieldBackground opacity={isHome ? 1 : 0.4} />
    <div id="header-container">
      <div id="logo-area">
      </div>
      {/* <nav id='website_nav'>
        <Link to="/">Home</Link>
        <Link to="/about">About</Link>
        <Link to="/events">Events</Link>
      </nav> */}


    </div>
      <main>
        <Outlet />
      </main>
    </>
  );
}
